<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col class="text-center text-sm-left flex-header mb-sm-0">
                <h3 class="page-title">Słowniki</h3>
                <d-button
                    theme="success"
                    @click.prevent="$router.push({name: 'dictionary-new'})">
                    <i class="material-icons">add</i> Dodaj pozycję
                </d-button>
            </d-col>
        </d-row>

        <!-- Default Light Table -->
        <template v-if="loadError">
            <d-alert
                show
                theme="warning">
                Wczytywanie danych nie powiodło się.
                <a
                    href="javascript:window.location.reload();"
                    class="alert-link">
                    Odśwież stronę
                </a>
                aby spróbować ponownie.
            </d-alert>
        </template>
        <template v-else>
            <transition name="fade">
                <d-card class="card-small">
                    <div
                        v-if="!loaded"
                        class="overlay-loading">
                        <h2 class="preloader isLoading">Trwa ładowanie</h2>
                    </div>
                    <d-card-header class="border-bottom">
                        <h6 class="m-0">Lista pozycji słownika</h6>
                    </d-card-header>

                    <d-card-body class="p-0 pb-3 text-center">
                        <table class="table mb-0 responsive-table">
                            <thead class="bg-light">
                                <tr>
                                    <th scope="col" class="border-0">Rzeczownik</th>
                                    <th scope="col" class="border-0">Dopełniacz</th>
                                    <th scope="col" class="border-0">Celownik</th>
                                    <th scope="col" class="border-0">Biernik</th>
                                    <th scope="col" class="border-0">Narzędnik</th>
                                    <th scope="col" class="border-0">Miejscownik</th>
                                    <th scope="col" class="border-0">Wołacz</th>
                                    <th scope="col" class="border-0 action-cell">Akcja</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(item) in dictionary"
                                    :key="dictionary.id">
                                    <td>
                                        <dt>Rzeczownik</dt>
                                        <dd>{{ item.rzeczownik }}</dd>
                                    </td>
                                    <td>
                                        <dt>Dopełniacz</dt>
                                        <dd>{{ item.dopelniacz }}</dd>
                                    </td>
                                    <td>
                                        <dt>Celownik</dt>
                                        <dd>{{ item.celownik }}</dd>
                                    </td>
                                    <td>
                                        <dt>Biernik</dt>
                                        <dd>{{ item.biernik }}</dd>
                                    </td>
                                    <td>
                                        <dt>Narzędnik</dt>
                                        <dd>{{ item.narzednik }}</dd>
                                    </td>
                                    <td>
                                        <dt>Miejscownik</dt>
                                        <dd>{{ item.miejscownik }}</dd>
                                    </td>
                                    <td>
                                        <dt>Wołacz</dt>
                                        <dd>{{ item.wolacz }}</dd>
                                    </td>

                                    <td>
                                        <dt>Akcja</dt>
                                        <dd>
                                            <d-button
                                                @click="editItem(item.id)"
                                                class="mr-3 my-1">
                                                <i class="material-icons">edit</i> Edytuj
                                            </d-button>
                                            <d-button
                                                theme="danger"
                                                @click="removeDictionaryItem(item.id)"
                                                class="my-1">
                                                <i class="material-icons">delete</i> Usuń
                                            </d-button>
                                        </dd>
                                    </td>
                                </tr>
                                <tr v-if="dictionary.length === 0">
                                    <td colspan="8" class="text-center text-info">
                                        Brak pozycji do wyświetlenia&hellip;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </d-card-body>
                    <d-card-footer>
                        <ss-pagination
                            :meta-data="paginationMetaData"
                            :initial-page="currentPage" />
                    </d-card-footer>
                </d-card>
            </transition>
        </template>
    </d-container>
</template>

<script>
import LarErrors from '@/helpers/Errors';
import ListUtils from '@/utils/ListUtils.js';
import SsPagination from '@/components/common/SsPaginationNew';
import HasPagination from '@/mixins/HasPagination.vue';

export default {
    name: 'Dictionary',
    mixins: [HasPagination],
    components: {
        LarErrors,
        SsPagination
    },
    data () {
        return {
            dictionary: [],
            lar_errors: LarErrors,
            loaded: false,
            loadError: false
        }
    },
    mounted () {
        this.loadItemsData();
    },
    methods: {
        loadItemsData () {
            ListUtils.loadItemsData(this, {
                method: 'post',
                endpoint: '/api/dictionary/items',
                listField: 'dictionary',
                pagination: true,
                params: {
                    page: this.currentPage
                }
            });
        },
        debouncedLoadFilteredData: _.debounce(function () {
            Vue.set(this, 'loaded', false);
            Vue.set(this, 'loadError', false);
            this.loadItemsData();
        }, 500),
        editItem (id) {
            this.$router.push({name: 'dictionary-edit', params: {id: id}})
        },
        removeDictionaryItem (itemID) {
            ListUtils.removeItem(this, {
                endpointBase: '/api/dictionary/delete/' + itemID,
                id: null,
                successTitle: 'Pozycja została usunięta.',
                successText: '',
                confirmTitle: 'Uwaga',
                confirmText: 'Czy potwierdzasz usunięcie pozycji?',
                errorTitle: 'Wystąpił błąd',
                errorText: 'Usuwanie pozycji nie powiodło się. Spróbuj ponownie.',
                successAction: () => {
                    this.actionInProgress = false;
                    this.debouncedLoadFilteredData();
                },
                failAction: () => {
                    this.actionInProgress = false;
                },
                cancelAction: () => {
                    this.actionInProgress = false;
                },
            });
        }
    }
}
</script>

<style lnag="scss" scoped>
.action-cell, .id-cell{
    width: 210px;
}
</style>
